var React = require('react');

function CloseSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m351.83-277.74-74.09-74.09L405.35-480 277.74-607.17l74.09-74.09L480-553.65l127.17-127.61 74.09 74.09L553.65-480l127.61 128.17-74.09 74.09L480-405.35 351.83-277.74Z"}));
}

CloseSmall.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = CloseSmall;

CloseSmall.default = CloseSmall;
